var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "plane-loading" }, [
    _c("h4", {
      staticClass: "plane-loading__text",
      domProps: { textContent: _vm._s(_vm.text) }
    }),
    _vm._v(" "),
    _c(
      "svg",
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          viewBox: "0 0 566 270.26"
        }
      },
      [
        _c(
          "defs",
          [
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "a",
                  x1: "64.83",
                  y1: "100.99",
                  x2: "64.83",
                  y2: "240.31",
                  gradientUnits: "userSpaceOnUse"
                }
              },
              [
                _c("stop", { attrs: { offset: "0", "stop-color": "#ad5c78" } }),
                _c("stop", { attrs: { offset: "1", "stop-color": "#d1796a" } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "b",
                  x1: "282.6",
                  y1: "90.56",
                  x2: "282.6",
                  y2: "-20.44",
                  gradientUnits: "userSpaceOnUse"
                }
              },
              [
                _c("stop", { attrs: { offset: "0", "stop-color": "#cb6157" } }),
                _c("stop", { attrs: { offset: "1", "stop-color": "#5a3074" } })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("g", { staticClass: "plane-loading__stars" }, [
          _c("path", {
            staticStyle: { opacity: "0.6", fill: "#fff" },
            attrs: {
              d:
                "M199.77,175.28c-2.3-1.17-4.59,0-5.74,2.35,1.15-2.35,0-4.7-2.29-5.87,2.29,1.17,4.59,0,5.73-2.35C196.33,171.76,197.47,174.11,199.77,175.28Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { opacity: "0.6", fill: "#fff" },
            attrs: {
              d:
                "M363.46,129.55c-3.44-2.35-8,0-10.32,3.52,2.29-3.52,0-8.22-3.44-10.57,3.44,2.35,8,0,10.32-3.52C357.72,123.68,358.87,128.37,363.46,129.55Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { opacity: "0.6", fill: "#fff" },
            attrs: {
              d:
                "M31.81,103.63c-3.44-2.35-8,0-10.32,3.52,2.29-3.52,0-8.22-3.44-10.57,3.44,2.35,8,0,10.32-3.52C26.08,97.75,27.22,102.45,31.81,103.63Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { opacity: "0.6", fill: "#fff" },
            attrs: {
              d:
                "M539.7,163.54a4.15,4.15,0,0,0-3.44,1.17,4.37,4.37,0,0,0-1.15-3.52,4.14,4.14,0,0,0,3.44-1.18C537.4,162.36,538.55,163.54,539.7,163.54Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { opacity: "0.6", fill: "#fff" },
            attrs: {
              d:
                "M435.77,22.28c-2.3-1.17-4.59,0-5.74,2.35,1.15-2.35,0-4.7-2.29-5.87,2.29,1.17,4.59,0,5.73-2.35C432.33,18.76,433.47,21.11,435.77,22.28Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { opacity: "0.6", fill: "#fff" },
            attrs: {
              d:
                "M117.7,41.54a4.15,4.15,0,0,0-3.44,1.17,4.37,4.37,0,0,0-1.15-3.52A4.14,4.14,0,0,0,116.55,38C115.4,40.36,116.55,41.54,117.7,41.54Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { opacity: "0.6", fill: "#fff" },
            attrs: {
              d:
                "M478.77,238.28c-2.3-1.17-4.59,0-5.74,2.35,1.15-2.35,0-4.7-2.29-5.87,2.29,1.17,4.59,0,5.73-2.35C475.33,234.76,476.47,237.11,478.77,238.28Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { opacity: "0.6", fill: "#fff" },
            attrs: {
              d:
                "M57.7,220.54a4.15,4.15,0,0,0-3.44,1.17,4.37,4.37,0,0,0-1.15-3.52A4.14,4.14,0,0,0,56.55,217C55.4,219.36,56.55,220.54,57.7,220.54Z"
            }
          })
        ]),
        _vm._v(" "),
        _c("g", { staticClass: "plane-loading__clouds" }, [
          _c("path", {
            staticStyle: { "fill-rule": "evenodd", fill: "url(#a)" },
            attrs: {
              d:
                "M110.18,227.11a13.11,13.11,0,0,0-5.34-19.84,18.63,18.63,0,0,0-4.8-.85c-2-.31-2.13-1.72-3.34-3.32a13.21,13.21,0,0,0-4.45-3.62c-1.94-1.08-2.12-1.68-3-3.66A16.66,16.66,0,0,0,70,186.59,15.76,15.76,0,0,0,65,188.91c-2,1.38-2.4,1.52-4.66.76a20.53,20.53,0,0,0-13.45,0,20.25,20.25,0,0,0-9.71,7.4,18.93,18.93,0,0,0-2.72,5.45c-.38,1.3-.26,3.21-1.53,3.92s-3.84.25-5.28.72a15.85,15.85,0,0,0-5.18,2.86A15.4,15.4,0,0,0,17,219.63,15.6,15.6,0,0,0,29.6,237c1.76.3,3.21-.16,4.93-.14s2.68,1.49,4.23,2.32a11.93,11.93,0,0,0,12.08-.53c1.15-.71,2.65-2.17,3.95-1.81.71.2,1.58,1.2,2.25,1.57a12.71,12.71,0,0,0,3.8,1.27,12.54,12.54,0,0,0,8.07-1.24c1-.56,2.37-2.41,3.46-2.32s3.06,2.35,4.21,2.81a12.81,12.81,0,0,0,8.22.47,13,13,0,0,0,9-8.82A13.15,13.15,0,0,0,110.18,227.11Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { "fill-rule": "evenodd", fill: "url(#a)" },
            attrs: {
              d:
                "M480,174.6c5.87-7.61,3.19-19.87-6.3-23.3-2.07-.75-4.62-.55-6.58-1.38-1.62-.69-2-2.25-3.07-3.72a15.86,15.86,0,0,0-4.92-4.22c-2.42-1.36-2.89-1.95-4-4.49a19.11,19.11,0,0,0-24.68-10c-2,.85-4,2.68-6.05,3.32-1.9.59-3.73-.74-5.69-1.21A23.9,23.9,0,0,0,392,141.66c-1.19,2.26-1.42,4.71-2.39,7-.64,1.49-.62,1.46-2.58,1.65-9.22.89-17.09,7.53-17.49,17.31a18.43,18.43,0,0,0,16.88,18.95c2.12.15,4.17-.51,6.09.45,2.22,1.1,3.86,2.55,6.36,3.15a15.32,15.32,0,0,0,7.25,0c2.6-.65,4-2.07,6.12-3.4,2.94-1.85,6.89,2.53,10.23,2.9a15.27,15.27,0,0,0,9-1.74c1.15-.64,2.48-2.19,3.75-2.25,1.85-.09,4.55,2.7,6.34,3.37a14.23,14.23,0,0,0,8.87,0,15.53,15.53,0,0,0,10.2-10.33A15.56,15.56,0,0,0,480,174.6Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { "fill-rule": "evenodd", fill: "url(#b)" },
            attrs: {
              d:
                "M332.63,61.82c5.64-7.31,2.58-18.33-5.89-21.88-1.81-.76-3.45-.66-5.29-.94-2.25-.34-2.35-1.9-3.69-3.66a14.73,14.73,0,0,0-4.91-4c-2.14-1.19-2.34-1.85-3.32-4a18.38,18.38,0,0,0-21.27-10.18,17.37,17.37,0,0,0-5.45,2.57c-2.21,1.51-2.64,1.67-5.14.83a22.24,22.24,0,0,0-25.56,8.2,20.92,20.92,0,0,0-3,6c-.42,1.43-.29,3.54-1.69,4.32s-4.23.28-5.83.8A17.39,17.39,0,0,0,235.89,43a17,17,0,0,0-6,10.55,17.2,17.2,0,0,0,13.87,19.18c2,.34,3.55-.17,5.44-.14s3,1.64,4.67,2.56a13.15,13.15,0,0,0,13.33-.59c1.26-.78,2.92-2.39,4.35-2,.79.22,1.74,1.33,2.48,1.73a13.54,13.54,0,0,0,4.19,1.4,13.76,13.76,0,0,0,8.91-1.36c1.08-.62,2.62-2.66,3.82-2.57s3.38,2.6,4.65,3.11a14.21,14.21,0,0,0,9.06.52,14.44,14.44,0,0,0,9.94-9.73A14.49,14.49,0,0,0,332.63,61.82Z"
            }
          })
        ]),
        _vm._v(" "),
        _c("g", { staticClass: "plane-loading__plane" }, [
          _c("path", {
            staticStyle: { fill: "#f6e8f0" },
            attrs: {
              d:
                "M20,121l17.08-.94,14,10.87S149,117.07,166.51,116.68s36.89,5.79,38.4,14c3,16.12-152.52,13.64-167.95,13Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#fff6fc" },
            attrs: {
              d:
                "M20,121l17.08-.94,14,10.87S149,117.07,166.51,116.68s36.89,5.79,38.4,14a1.71,1.71,0,0,1,0,.32c-.61-.55-10.86-9.57-28.53-11.77C158.16,117,50.81,133.06,50.81,133.06l-14.19-11.3-15.27,1Z"
            }
          }),
          _vm._v(" "),
          _c("polygon", {
            staticStyle: { fill: "#fff6fc" },
            attrs: {
              points:
                "132.22 120.13 87.32 104.06 76.95 105.21 104.48 123.65 132.22 120.13"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#659fe6" },
            attrs: {
              d:
                "M79.14,133.09l2.53-.21A1.21,1.21,0,0,1,83,134l.12,1.45A1.22,1.22,0,0,1,82,136.73l-2.52.2a1.2,1.2,0,0,1-1.29-1.1L78,134.37A1.2,1.2,0,0,1,79.14,133.09Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#659fe6" },
            attrs: {
              d:
                "M88.42,132.46l2.52-.2a1.22,1.22,0,0,1,1.29,1.11l.11,1.45a1.22,1.22,0,0,1-1.1,1.29l-2.53.2a1.2,1.2,0,0,1-1.28-1.11l-.12-1.45A1.22,1.22,0,0,1,88.42,132.46Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#659fe6" },
            attrs: {
              d:
                "M97.7,131.84l2.51-.2a1.2,1.2,0,0,1,1.29,1.1l.11,1.46a1.2,1.2,0,0,1-1.11,1.28l-2.52.21a1.22,1.22,0,0,1-1.29-1.11l-.11-1.46A1.2,1.2,0,0,1,97.7,131.84Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#659fe6" },
            attrs: {
              d:
                "M107,131.21l2.53-.2a1.21,1.21,0,0,1,1.28,1.11l.12,1.45a1.21,1.21,0,0,1-1.11,1.29l-2.53.21A1.2,1.2,0,0,1,106,134l-.12-1.46A1.22,1.22,0,0,1,107,131.21Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#659fe6" },
            attrs: {
              d:
                "M116.25,130.59l2.52-.2a1.22,1.22,0,0,1,1.29,1.1l.12,1.46a1.22,1.22,0,0,1-1.11,1.29l-2.52.2a1.22,1.22,0,0,1-1.29-1.11l-.12-1.45A1.22,1.22,0,0,1,116.25,130.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#659fe6" },
            attrs: {
              d:
                "M125.52,130l2.52-.2a1.19,1.19,0,0,1,1.28,1.1l.12,1.46a1.2,1.2,0,0,1-1.11,1.28l-2.52.2a1.21,1.21,0,0,1-1.29-1.11l-.12-1.45A1.21,1.21,0,0,1,125.52,130Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#659fe6" },
            attrs: {
              d:
                "M134.8,129.36l2.52-.2a1.22,1.22,0,0,1,1.29,1.11l.12,1.45a1.23,1.23,0,0,1-1.11,1.29l-2.53.2a1.2,1.2,0,0,1-1.28-1.11l-.12-1.45A1.22,1.22,0,0,1,134.8,129.36Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#659fe6" },
            attrs: {
              d:
                "M144.08,128.72l2.52-.2a1.2,1.2,0,0,1,1.28,1.1l.12,1.46a1.22,1.22,0,0,1-1.11,1.29l-2.52.2a1.23,1.23,0,0,1-1.29-1.11L143,130A1.2,1.2,0,0,1,144.08,128.72Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#659fe6" },
            attrs: {
              d:
                "M153.35,128.08l2.52-.21a1.22,1.22,0,0,1,1.29,1.12l.12,1.45a1.22,1.22,0,0,1-1.11,1.29l-2.53.2a1.2,1.2,0,0,1-1.28-1.11l-.12-1.45A1.21,1.21,0,0,1,153.35,128.08Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#659fe6" },
            attrs: {
              d:
                "M197.05,122.7l-7.41.93c-3.95,1.4-1.71,6.32,1.41,6l12.87-1.45C202.61,126.18,200.2,124.31,197.05,122.7Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#c3aac6" },
            attrs: {
              d:
                "M204.91,130.65C179.35,142.23,67.14,143,35.51,141.72L37,143.65C52.39,144.3,207.87,146.78,204.91,130.65Z"
            }
          }),
          _vm._v(" "),
          _c("polygon", {
            staticStyle: { fill: "#fff6fc" },
            attrs: {
              points:
                "141.08 139.77 82.73 181.46 73.95 179.39 104.22 141.62 141.08 139.77"
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "g",
          {
            staticClass: "plane-loading__lines",
            staticStyle: { opacity: "0.2" }
          },
          [
            _c("line", {
              staticStyle: {
                fill: "none",
                stroke: "#fff",
                "stroke-linejoin": "round"
              },
              attrs: { x1: "529", y1: "1", x2: "74", y2: "1" }
            }),
            _vm._v(" "),
            _c("line", {
              staticStyle: {
                fill: "none",
                stroke: "#fff",
                "stroke-linejoin": "round"
              },
              attrs: { x1: "432", y1: "52.79", y2: "52.79" }
            }),
            _vm._v(" "),
            _c("line", {
              staticStyle: {
                fill: "none",
                stroke: "#fff",
                "stroke-linejoin": "round"
              },
              attrs: { x1: "250", y1: "102", x2: "8", y2: "102" }
            }),
            _vm._v(" "),
            _c("line", {
              staticStyle: {
                fill: "none",
                stroke: "#fff",
                "stroke-linejoin": "round"
              },
              attrs: { x1: "545", y1: "129", x2: "235", y2: "129" }
            }),
            _vm._v(" "),
            _c("line", {
              staticStyle: {
                fill: "none",
                stroke: "#fff",
                "stroke-linejoin": "round"
              },
              attrs: { x1: "320", y1: "156", x2: "85", y2: "156" }
            }),
            _vm._v(" "),
            _c("line", {
              staticStyle: {
                fill: "none",
                stroke: "#fff",
                "stroke-linejoin": "round"
              },
              attrs: { x1: "566", y1: "195", x2: "134", y2: "195" }
            }),
            _vm._v(" "),
            _c("line", {
              staticStyle: {
                fill: "none",
                stroke: "#fff",
                "stroke-linejoin": "round"
              },
              attrs: { x1: "440", y1: "252", y2: "252" }
            })
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a11c678", { render: render, staticRenderFns: staticRenderFns })
  }
}